module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), _c('bank-account-changed-warning', {
    attrs: {
      "isVisible": _vm.isBankAccountChangedWarningVisible,
      "isAdminView": true
    },
    on: {
      "close": _vm.hideBankAccountChangedWarning,
      "goToUpcomingTransactions": _vm.handleGoToUpcomingTransactions
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.userDetailLoading ||
    _vm.accountUsersLoading ||
    _vm.isNotesSegmentLoading ||
    _vm.isFundingSourcesSegmentLoading ||
    _vm.preferencesSpinner ||
    _vm.isUpcomingTransactionsSegmentLoading ||
    _vm.isAdditionalEmailsLoading ||
    _vm.isRepresentativesLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Account information")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('RestrictedSingleInput', {
    attrs: {
      "input": _vm.organization.name,
      "limit": 40
    },
    on: {
      "inputUpdated": _vm.onInstitutionNameUpdate
    }
  }), _vm._v(" "), (_vm.organization && _vm.organization.name && _vm.organization.name.trim().length === 0) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.accountId) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row space zero-margin-x"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.formatDate(_vm.account.createdAt)) + " ")])])])]), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.investorSince) + " ")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [(_vm.account.status == 'active') ? _c('p', {
    staticClass: "label label-success capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'pending') ? _c('p', {
    staticClass: "label label-warning capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'inactive') ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.hasUserComments) ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" Comments ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.type),
      expression: "organization.type"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('institutionType')
    },
    attrs: {
      "name": "institutionType",
      "id": "institutionType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.organization.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.institutionTypes), function(institutionType, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": institutionType.name
      }
    }, [_vm._v("\n                        " + _vm._s(institutionType.text) + "\n                      ")])
  })), _vm._v(" "), (_vm.errors.has('institutionType')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.taxId),
      expression: "organization.taxId"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('99-9999999'),
      expression: "'99-9999999'"
    }],
    class: {
      'form-control': true,
      'form-control-error': _vm.errors.has('taxId') || !_vm.isTaxIdValid()
    },
    attrs: {
      "name": "taxId",
      "id": "taxId"
    },
    domProps: {
      "value": (_vm.organization.taxId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization.taxId = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('taxId') || !_vm.isTaxIdValid()) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.phoneNumber),
      expression: "organization.phoneNumber"
    }],
    class: {
      'form-control': true,
      'form-control-error': _vm.errors.has('phone') || !_vm.isPhoneNumberValid()
    },
    attrs: {
      "name": "phone",
      "id": "phone"
    },
    domProps: {
      "value": (_vm.organization.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('phone') || !_vm.isPhoneNumberValid()) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.legacyUsername) + " ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.legacyCustomerNumber) + " ")])])])])])]), _vm._v(" "), (_vm.organization.mainAddress && _vm.organization.mailingAddress) ? _c('Addresses', {
    key: 1,
    ref: "addresses",
    attrs: {
      "firstTitle": 'Institution Address',
      "residentialAddress": _vm.organization.mainAddress,
      "secondTitle": 'Mailing Address',
      "mailingAddress": _vm.organization.mailingAddress,
      "is-admin": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "disabled": _vm.shouldSubmitButtonBeDisabled()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitAccount()
      }
    }
  }, [_vm._v("\n                  Submit account information\n                ")])])])], 1)])]), _vm._v(" "), (_vm.accountRepresentatives !== undefined) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountEmails', {
    attrs: {
      "accountId": _vm.accountId,
      "emails": _vm.accountEmails
    },
    on: {
      "additionalEmailsAddingFailed": _vm.setAdditionalEmailSpinnerOff,
      "additionalEmailsAddingStarted": _vm.setAdditionalEmailSpinnerOn,
      "additionalEmailsAddingSucceed": _vm.setAdditionalEmailSpinnerOff,
      "additionalEmailsDeletingFailed": _vm.setAdditionalEmailSpinnerOff,
      "additionalEmailsDeletingStarted": _vm.setAdditionalEmailSpinnerOn,
      "additionalEmailsDeletingSucceed": _vm.setAdditionalEmailSpinnerOff
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.accountRepresentatives !== undefined && _vm.account.primaryInvestorId) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountRepresentatives', {
    attrs: {
      "accountId": _vm.accountId,
      "accountName": _vm.accountName,
      "accountType": _vm.getAccountType(),
      "representatives": _vm.accountRepresentatives,
      "primaryInvestorId": _vm.account.primaryInvestorId
    },
    on: {
      "representativesLoadingStarted": _vm.setRepresentativesSpinnerOn,
      "representativesLoadingSucceed": _vm.setRepresentativesSpinnerOff,
      "representativesLoadingFailed": _vm.setRepresentativesSpinnerOff,
      "representativesUpdated": _vm.loadAccountInformation
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountNotes', {
    attrs: {
      "accountId": _vm.accountId,
      "displayAlertForUpcomingTransactionsWithAction": _vm.shouldUpcomingTransactionsWithActionsBeDisplayed,
      "displayAlertForUpcomingTransactionsWithNoAction": _vm.shouldUpcomingTransactionsWithNoActionsBeDisplayed,
      "disable-investment": _vm.user.disableInvestment || _vm.organization.disableInvestment
    },
    on: {
      "goToUpcomingTransactionsSegment": function($event) {
        _vm.goToSegment('upcoming-transactions-segment')
      },
      "notesLoadingFailed": _vm.setNotesSpinnerOff,
      "notesLoadingStarted": _vm.setNotesSpinnerOn,
      "notesLoadingSucceed": _vm.setNotesSpinnerOff,
      "redirectToNoteDetailsView": _vm.goToViewDetail,
      "redirectToPurchaseInvestmentNoteView": _vm.goToPurchaseInvestmentNote
    }
  })], 1)]), _vm._v(" "), (_vm.account.defaultFundingSourceId !== undefined) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "funding-sources-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountFundingSources', {
    attrs: {
      "accountId": _vm.accountId,
      "defaultFundingSourceId": _vm.userAccount.defaultFundingSourceId,
      "account": _vm.account
    },
    on: {
      "fundingSourcesLoadingFailed": _vm.setFundingSourceSpinnerOff,
      "fundingSourcesLoadingStarted": _vm.setFundingSourceSpinnerOn,
      "fundingSourcesLoadingSucceed": _vm.setFundingSourceSpinnerOff,
      "defaultFundingSourceUpdated": _vm.handleDefaultFundingSourceUpdated,
      "restart": _vm.loadAccountUsers,
      "showBankAccountChangedWarning": _vm.showBankAccountChangedWarning
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AdminAccountDocuments')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "preferences-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Preferences\n          ")]), _vm._v(" "), _c('SuccessAlert', {
    attrs: {
      "isVisible": _vm.isPreferencesSuccessMessageVisible,
      "message": _vm.preferencesSuccessMessage
    },
    on: {
      "hideSuccessAlert": _vm.hidePreferencesSuccessMessage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.account.communicationPreference !== undefined) ? _c('AccountPreferences', {
    attrs: {
      "accountId": _vm.accountId,
      "interestPreference": _vm.account.interestPreference,
      "communicationPreference": _vm.account.communicationPreference,
      "communication1099Preference": _vm.account.communication1099Preference,
      "communicationImpactReportPreference": _vm.account.communicationImpactReportPreference,
      "paymentPreference": _vm.account.paymentPreference,
      "redemptionRestriction": _vm.account.redemptionRestriction,
      "user": _vm.user
    },
    on: {
      "impactPreferencesLoadingFailed": _vm.setPreferencesSpinnerOff,
      "impactPreferencesLoadingStarted": _vm.setPreferencesSpinnerOn,
      "impactPreferencesLoadingSucceed": _vm.setPreferencesSpinnerOff,
      "updateImpactPreferencesFailed": _vm.setPreferencesSpinnerOff,
      "updateImpactPreferencesStarted": _vm.setPreferencesSpinnerOn,
      "updateImpactPreferencesSucceed": _vm.displayImpactPreferenceSuccessfulNotification
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "upcoming-transactions-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('UpcomingTransactions', {
    ref: "upcomingTransactions",
    attrs: {
      "accountId": _vm.accountId,
      "defaultFundingSourceId": _vm.userAccount.defaultFundingSourceId,
      "investorAccountIdentifier": _vm.userAccount.accountId
    },
    on: {
      "goToFundingSourcesSegment": function($event) {
        _vm.goToSegment('funding-sources-segment')
      },
      "hideAlertForUpcomingTransactions": _vm.hideUpcomingTransactionsAlerts,
      "showAlertForUpcomingTransactionsWithAction": _vm.displayUpcomingTransactionsWithActionAlert,
      "showAlertForUpcomingTransactionsWithNoAction": _vm.displayUpcomingTransactionsWithNoActionAlert,
      "upcomingTransactionsLoadingFailed": _vm.setUpcomingTransactionsSpinnerOff,
      "upcomingTransactionsLoadingStarted": _vm.setUpcomingTransactionsSpinnerOn,
      "upcomingTransactionsLoadingSucceed": _vm.setUpcomingTransactionsSpinnerOff
    }
  })], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Institution account\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Institution name *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("ID")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v("Date Created:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Investor since:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Status:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Institution type *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Tax ID *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Phone number *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Legacy Username:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Legacy Customer Number:")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94c12a3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditInstitutionAccount.vue
// module id = 2191
// module chunks = 1